import * as z from "zod";

export const getChargebacksScopeStatus = {
  name: "getChargebacksScopeStatus" as const,
  input: z.object({}),
  output: z.object({
    hasRequiredScopes: z.boolean(),
    updatePermissionsLink: z.string().nullable(),
  }),
};
